let retryTimer: ReturnType<typeof setTimeout> | undefined;
let onRetry: (() => void) | undefined;

export const setMessagingMaintenanceRetryHandler = (handler: () => void) => {
  onRetry = handler;
};

export const scheduleMessagingMaintenanceRetry = (seconds: number) => {
  if (retryTimer !== undefined) return;

  retryTimer = setTimeout(() => {
    retryTimer = undefined;
    onRetry?.();
  }, seconds * 1000);
};
